export const LIVE_STREAM_ROOM_PREFIX = 'live-stream:';
export const LIVE_STREAM_SEALED_CONTENT_ROOM_SUFFIX = ':sealed-content';
export function getLiveStreamRoom(recordingId) {
    return `${LIVE_STREAM_ROOM_PREFIX}${recordingId}`;
}
export function getLiveStreamSealedContentRoom(recordingId) {
    return `${LIVE_STREAM_ROOM_PREFIX}${recordingId}${LIVE_STREAM_SEALED_CONTENT_ROOM_SUFFIX}`;
}
